import styled from 'styled-components';

export const Term = styled('span')`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.7)};
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  width: fit-content;
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;
